// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3i1nF","modalForm":"UpgradeEpcsModal_modalForm__auoCM","modalFooter":"UpgradeEpcsModal_modalFooter__2v4FD"};